export const validateCpf = (cpf) => {
  if (!cpf) return false;
  const digits = cpf.replace(/\D/g, "");

  if (digits.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(digits)) return false;

  const calcDigit = (base, factor) =>
    base.split("").reduce((acc, d, i) => acc + Number(d) * (factor - i), 0);

  const rem1 = (calcDigit(digits.slice(0, 9), 10) * 10) % 11;
  const d1 = rem1 >= 10 ? 0 : rem1;

  const rem2 = (calcDigit(digits.slice(0, 10), 11) * 10) % 11;
  const d2 = rem2 >= 10 ? 0 : rem2;

  return d1 === Number(digits[9]) && d2 === Number(digits[10]);
};
